export default __webpack_public_path__ + "static/media/girl-ellipse.227c86c9.png";